/* eslint-disable */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);


const Header = {
  init: function () {
    this.magicLineAnim();
    this.mobileNav();
  },

  magicLineAnim: function () {
    const header = document.querySelector("[data-header-js]");
    const body = document.querySelector("body");
    if (!header) return;

    ScrollTrigger.create({
      trigger: body,
      start: "top top",
      end: "bottom top",
      // markers: true,
      onUpdate: (self) => {
        if (self.progress === 0) {
          header.classList.remove("is-small");
        } else {
          header.classList.add("is-small");
        }
      },
    });
  },

  mobileNav: function () {
    const body = document.querySelector("body");
    const openNavTrigger = document.querySelector("[data-open-nav-js]");
    const overlay = document.querySelector("[data-header-overlay-js]");

    openNavTrigger.addEventListener("click", () => {
      if (body.classList.contains("navigationOpen")) {
        this.closeMobileNav();
      } else {
        this.openMobileNav();
      }
    });

    overlay.addEventListener("click", () => {
      this.closeMobileNav();
    });
  },

  openMobileNav: function () {
    const body = document.querySelector("body");
    const html = document.querySelector("html");

    html.classList.add("overflowHidden");
    body.classList.add("overflowHidden");
    body.classList.add("navigationOpen");
  },

  closeMobileNav: function () {
    const body = document.querySelector("body");
    const html = document.querySelector("html");

    html.classList.remove("overflowHidden");
    body.classList.remove("overflowHidden");
    body.classList.remove("navigationOpen");
  },
};

export default Header;

const progressWrap = document.querySelector(".scroll-progress");
const progressBar = progressWrap?.querySelector(".scroll-progress__bar");

if (progressWrap && progressBar) {
  const updateProgress = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? scrollTop / docHeight : 0;

    progressBar.style.transform = `scaleX(${progress})`;
    progressBar.style.transformOrigin = "left center";

    if (progress < 0.01 ) {
      progressWrap.style.opacity = "0";
    } else {
      progressWrap.style.opacity = "1";
    }
  };

  updateProgress();
  window.addEventListener("scroll", updateProgress, { passive: true });
  window.addEventListener("resize", updateProgress);

  ScrollTrigger.addEventListener("refresh", updateProgress);
  ScrollTrigger.refresh();
}
